(function () {
  'use strict';

  if (window.__ANATOMY_POSTHOG_LOADED__) return;
  window.__ANATOMY_POSTHOG_LOADED__ = true;

  var config = window.ANATOMY_POSTHOG_CONFIG || {};
  if (!config.projectKey || !config.apiHost) return;

  var VERSION = '2026-09-25.2-channel-tracking';
  var FUNNEL_SCHEMA_VERSION = 'funnel_context_v2';

  // Capture options for any event fired from a control that can navigate the
  // document: link clicks, checkout redirects, cart adds that redirect. The
  // SDK's default transport queues the request, and a navigation cancels it in
  // flight. sendBeacon is handed to the browser, which delivers it regardless
  // of unload. Measured before the fix: only 76.5% of in-session page
  // transitions had a surviving click event, and add-to-cart events were lost
  // at 38-47% on the landing page whose buy controls redirect to checkout.
  var UNLOAD_SAFE_CAPTURE = { transport: 'sendBeacon', send_instantly: true };
  var ATTRIBUTION_KEY = 'anatomy_attribution_v1';
  var SESSION_KEY = 'anatomy_attribution_session_v1';
  var FUNNEL_SESSION_KEY = 'anatomy_funnel_session_v1';
  var BROWSER_FIRST_SEEN_KEY = 'anatomy_browser_first_seen_v1';
  var CART_CONTEXT_KEY = 'anatomy_cart_context_v1';
  var POSTHOG_CART_SYNC_KEY = 'anatomy_posthog_cart_sync_v1';
  var CART_ATTRIBUTION_SYNC_HEADER = 'X-Anatomy-Cart-Attribution-Sync';
  var CHECKOUT_INTENT_KEY = 'anatomy_checkout_intent_v1';
  var CHECKOUT_HANDOFF_KEY = 'anatomy_checkout_handoff_v1';
  var FUNNEL_STATE_KEY = 'anatomy_funnel_state_v1';
  var OFFER_SIGNAL_KEY = 'anatomy_offer_signal_v1';
  var VISITOR_ID_KEY = 'anatomy_visitor_id_v1';
  var SCROLL_DEPTHS = [25, 50, 75, 90];
  var scrollSeen = {};
  var pageQualityCaptured = false;
  var largestContentfulPaintMs = 0;
  var MARKETING_QUERY_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'utm_placement', 'utm_site',
    'utm_id', 'utm_adset_id', 'utm_ad_id', 'campaign_id', 'adset_id',
    'ad_group_id', 'adgroup_id', 'ad_id', 'creative_id', 'discount', 'offer',
    'sv1'
  ];
  // Same list as CLICK_ID_KEYS in anatomy-attribution.js.
  var AD_QUERY_KEYS = [
    'fbclid', 'gclid', 'gclsrc', 'dclid', 'gbraid', 'wbraid', 'gad_source',
    'ttclid', 'twclid', 'li_fat_id', 'igshid', 'rdt_cid', 'qclid', 'sccid',
    'msclkid', 'epik', 'irclid', '_kx', 'mc_cid', 'mc_eid',
    'awc', 'sscid', 'lbclid', 'lb_hash', 'srsltid'
  ];
  var ANALYTICS_CART_ATTRIBUTE_SUFFIXES = [
    'anatomy_visitor_id', 'posthog_distinct_id', 'posthog_session_id',
    'schema_version', 'funnel_session_id', 'cart_token',
    'experiment_id', 'experiment_version', 'experiment_phase',
    'experiment_variant', 'experiment_bucket', 'experiment_assigned_at',
    'experiment_is_qa_forced', 'protocol_choice_experiment_variant',
    'checkout_path_experiment_variant',
    'protocol_choice_experiment_is_qa_forced',
    'checkout_path_experiment_is_qa_forced', 'current_page_url',
    'current_page_path', 'checkout_intent_id', 'parent_checkout_intent_id',
    'checkout_intent_source', 'checkout_intent_started_at',
    'checkout_intent_page_url', 'checkout_intent_page_path',
    'checkout_intent_referrer', 'checkout_intent_cta_text',
    'checkout_intent_cta_id', 'checkout_intent_cta_slot',
    'checkout_intent_cta_action', 'checkout_intent_cta_label_normalized',
    'checkout_intent_cta_href', 'checkout_intent_cta_location',
    'checkout_intent_variant_id', 'checkout_intent_form_action',
    'checkout_behavior'
  ];
  var MARKETING_CART_ATTRIBUTE_SUFFIXES = [
    'first_landing_url', 'first_landing_path', 'first_referrer',
    'first_utm_source', 'first_utm_medium', 'first_utm_campaign',
    'first_utm_content', 'first_utm_term', 'first_utm_placement',
    'first_utm_site', 'first_utm_id',
    'first_utm_adset_id', 'first_utm_ad_id', 'first_fbclid', 'first_gclid',
    'first_gbraid', 'first_wbraid', 'first_ttclid', 'first_msclkid',
    'first_timestamp', 'last_landing_url', 'last_landing_path',
    'last_referrer', 'last_utm_source', 'last_utm_medium',
    'last_utm_campaign', 'last_utm_content', 'last_utm_term',
    'last_utm_placement', 'last_utm_site', 'last_utm_id',
    'last_utm_adset_id', 'last_utm_ad_id', 'last_fbclid', 'last_gclid',
    'last_gbraid', 'last_wbraid', 'last_ttclid', 'last_msclkid',
    'last_timestamp', 'fbp', 'fbc', 'session_entry_url',
    'session_entry_path', 'session_referrer', 'normalized_first_source',
    'normalized_last_source', 'quality', 'is_paid_traffic', 'offer_code',
    'active_offer_code', 'first_channel', 'first_platform', 'last_channel',
    'last_platform'
  ];
  var AD_CART_ATTRIBUTE_SUFFIXES = [
    'first_fbclid', 'first_gclid', 'first_gbraid', 'first_wbraid',
    'first_ttclid', 'first_msclkid', 'last_fbclid', 'last_gclid',
    'last_gbraid', 'last_wbraid', 'last_ttclid', 'last_msclkid', 'fbp', 'fbc'
  ];

  function cartAttributeKeys(suffixes) {
    return suffixes.map(function (suffix) {
      return 'attribution_' + suffix;
    });
  }

  var ANALYTICS_CART_ATTRIBUTE_KEYS = cartAttributeKeys(ANALYTICS_CART_ATTRIBUTE_SUFFIXES);
  var MARKETING_CART_ATTRIBUTE_KEYS = cartAttributeKeys(MARKETING_CART_ATTRIBUTE_SUFFIXES);
  var AD_CART_ATTRIBUTE_KEYS = cartAttributeKeys(AD_CART_ATTRIBUTE_SUFFIXES);
  var ALL_TRACKING_CART_ATTRIBUTE_KEYS = ANALYTICS_CART_ATTRIBUTE_KEYS.concat(MARKETING_CART_ATTRIBUTE_KEYS);

  function analyticsAllowed() {
    var privacy = window.AnatomyCustomerPrivacy;
    return !!privacy
      && typeof privacy.analyticsAllowed === 'function'
      && privacy.analyticsAllowed() === true;
  }

  function marketingAllowed() {
    var privacy = window.AnatomyCustomerPrivacy;
    return !!privacy
      && typeof privacy.marketingAllowed === 'function'
      && privacy.marketingAllowed() === true;
  }

  function advertisingAllowed() {
    var privacy = window.AnatomyCustomerPrivacy;
    return !!privacy
      && typeof privacy.advertisingAllowed === 'function'
      && privacy.advertisingAllowed() === true;
  }

  function removeStorage(storage, key) {
    try {
      storage.removeItem(key);
    }
    catch (error) {}
  }

  function deleteCookie(name) {
    try {
      document.cookie = encodeURIComponent(name) + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
      var hostname = String(window.location && window.location.hostname || '').replace(/^www\./i, '');
      if (hostname && hostname.indexOf('.') !== -1) {
        document.cookie = encodeURIComponent(name) + '=; Max-Age=0; Path=/; Domain=.' + hostname + '; SameSite=Lax; Secure';
      }
    }
    catch (error) {}
  }

  function cookieValue(name) {
    var pairs = String(document.cookie || '').split(';');
    for (var index = 0; index < pairs.length; index += 1) {
      var pair = pairs[index].split('=');
      var key = pair[0].trim();
      try { key = decodeURIComponent(key); }
      catch (error) {}
      if (key === name) return pair.slice(1).join('=').trim();
    }
    return '';
  }

  // Internal and automated traffic. `?anatomy_internal=1` on any storefront URL
  // marks this browser as internal with a first-party flag cookie (no
  // identifier; it only exists for people who open that link) and
  // `?anatomy_internal=0` clears it. Both flags become super properties, so
  // PostHog's internal/test-user filter also covers SDK-captured events.
  var INTERNAL_COOKIE = 'anatomy_internal';

  function detectInternalTraffic() {
    var flag = '';
    try { flag = new URLSearchParams(window.location.search).get('anatomy_internal') || ''; }
    catch (error) {}
    if (flag === '1') {
      try { document.cookie = INTERNAL_COOKIE + '=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; }
      catch (error) {}
      return true;
    }
    if (flag === '0') {
      deleteCookie(INTERNAL_COOKIE);
      return false;
    }
    return cookieValue(INTERNAL_COOKIE) === '1';
  }

  var IS_INTERNAL = detectInternalTraffic();
  var IS_AUTOMATION = !!(window.navigator && window.navigator.webdriver === true);

  function postHogPersistencePrefix() {
    return 'ph_' + String(config.projectKey || '') + '_';
  }

  function ownedPostHogPersistenceKey(key) {
    var prefix = postHogPersistencePrefix();
    return prefix.length > 4 && String(key || '').indexOf(prefix) === 0;
  }

  function storageKeys(storage) {
    var keys = [];
    try {
      for (var index = 0; index < storage.length; index += 1) {
        var key = storage.key(index);
        if (key) keys.push(key);
      }
    }
    catch (error) {}
    return keys;
  }

  function clearPostHogPersistence() {
    [window.localStorage, window.sessionStorage].forEach(function (storage) {
      storageKeys(storage).forEach(function (key) {
        if (ownedPostHogPersistenceKey(key)) removeStorage(storage, key);
      });
    });

    try {
      String(document.cookie || '').split(';').forEach(function (part) {
        var rawName = part.split('=')[0].trim();
        if (!rawName) return;
        var name = rawName;
        try { name = decodeURIComponent(rawName); }
        catch (error) {}
        if (ownedPostHogPersistenceKey(name)) deleteCookie(name);
      });
    }
    catch (error) {}
  }

  function clearTrackingState() {
    [VISITOR_ID_KEY, BROWSER_FIRST_SEEN_KEY, FUNNEL_STATE_KEY].forEach(function (key) {
      removeStorage(window.localStorage, key);
    });
    [FUNNEL_SESSION_KEY, CART_CONTEXT_KEY, POSTHOG_CART_SYNC_KEY, CHECKOUT_INTENT_KEY, CHECKOUT_HANDOFF_KEY, OFFER_SIGNAL_KEY, 'anatomy_offer_code_v1'].forEach(function (key) {
      removeStorage(window.sessionStorage, key);
    });
    deleteCookie('anatomy_visitor_id');
    clearPostHogPersistence();
  }

  function readJson(key) {
    if (!analyticsAllowed()) return {};
    try {
      var value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : {};
    }
    catch (error) {
      return {};
    }
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'an_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
  }

  function visitorId() {
    if (!analyticsAllowed()) return '';
    try {
      var stored = window.localStorage.getItem(VISITOR_ID_KEY);
      if (stored) return stored;
      stored = uuid();
      window.localStorage.setItem(VISITOR_ID_KEY, stored);
      return stored;
    }
    catch (error) {
      return uuid();
    }
  }

  function writeVisitorCookie(id) {
    if (!id || !analyticsAllowed()) return;
    try {
      document.cookie = 'anatomy_visitor_id=' + encodeURIComponent(id) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    }
    catch (error) {}
  }

  function directSessionId() {
    if (window.posthog && typeof window.posthog.get_session_id === 'function') {
      var sessionId = window.posthog.get_session_id();
      if (sessionId) return String(sessionId);
    }
    return '';
  }

  function directDistinctId() {
    if (window.posthog && typeof window.posthog.get_distinct_id === 'function') {
      var distinctId = window.posthog.get_distinct_id();
      if (distinctId) return String(distinctId);
    }
    return '';
  }

  function persistVisitorId(id) {
    if (!id || !analyticsAllowed()) return '';
    try {
      window.localStorage.setItem(VISITOR_ID_KEY, id);
    }
    catch (error) {}
    writeVisitorCookie(id);
    return id;
  }

  function synchronizeVisitorIdWithPostHog() {
    var distinctId = directDistinctId();
    return distinctId ? persistVisitorId(distinctId) : visitorId();
  }

  function textOf(element) {
    if (!element) return '';
    var text = element.getAttribute('aria-label')
      || element.getAttribute('title')
      || element.getAttribute('value')
      || element.textContent
      || '';
    return String(text).replace(/\s+/g, ' ').trim().slice(0, 140);
  }

  function truncate(value, length) {
    if (value === null || typeof value === 'undefined') return '';
    var stringValue = String(value);
    if (stringValue.length <= length) return stringValue;
    return stringValue.slice(0, Math.max(length - 3, 0)) + '...';
  }

  function closestLabel(element) {
    var parent = element && element.closest
      ? element.closest('section, header, footer, main, [id], [class*="lp-"], [data-section-type]')
      : null;
    if (!parent) return '';
    return (parent.getAttribute('id') || parent.getAttribute('data-section-type') || parent.className || '').toString().slice(0, 180);
  }

  function safeUrl(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url || window.location.href, window.location.origin);
      ['email', 'e', 'phone', 'name', 'first_name', 'last_name', 'address', 'token', 'password'].forEach(function (key) {
        parsed.searchParams.delete(key);
      });
      if (!marketingAllowed()) {
        MARKETING_QUERY_KEYS.concat(AD_QUERY_KEYS).forEach(function (key) {
          parsed.searchParams.delete(key);
        });
      }
      else if (!advertisingAllowed()) {
        AD_QUERY_KEYS.forEach(function (key) {
          parsed.searchParams.delete(key);
        });
      }
      return parsed.href;
    }
    catch (error) {
      return '';
    }
  }

  function pathFromUrl(url) {
    try {
      return new URL(url || window.location.href, window.location.origin).pathname;
    }
    catch (error) {
      return window.location.pathname || '';
    }
  }

  function productModuleProps(element) {
    var module = element && element.closest ? element.closest('[data-an-product-module]') : null;
    if (!module) return {};
    var selector = element && element.closest ? element.closest('[data-an-system-selector]') : null;
    if (!selector && module.matches && module.matches('[data-an-system-selector]')) selector = module;
    var selectorCard = element && element.closest ? element.closest('[data-an-selector-card]') : null;
    var productContext = selectorCard || module;
    var form = productContext.querySelector ? productContext.querySelector('form[action*="/cart/add"], [data-lp-checkout-form]') : null;
    var variantInput = form && form.querySelector ? form.querySelector('[name="id"]') : null;
    var cta = form && form.querySelector ? form.querySelector('button[type="submit"], input[type="submit"], a[href]') : null;
    return {
      module_identifier: module.getAttribute('data-an-module-id') || module.getAttribute('id') || '',
      module_slot: module.getAttribute('data-an-module-slot') || '',
      product_module_id: module.getAttribute('id') || '',
      product_module_location: closestLabel(module),
      product_module_text_sample: textOf(module).slice(0, 220),
      selector_id: (selectorCard && selectorCard.getAttribute('data-selector-id')) || (selector && selector.getAttribute('data-selector-id')) || '',
      selector_choice: (selectorCard && selectorCard.getAttribute('data-selector-choice')) || '',
      selector_role: (selectorCard && selectorCard.getAttribute('data-selector-role')) || '',
      product_handle: (selectorCard && selectorCard.getAttribute('data-product-handle')) || module.getAttribute('data-product-handle') || '',
      product_title: (selectorCard && selectorCard.getAttribute('data-product-title')) || module.getAttribute('data-product-title') || '',
      product_price: (selectorCard && selectorCard.getAttribute('data-product-price')) || module.getAttribute('data-product-price') || '',
      product_available: (selectorCard && selectorCard.getAttribute('data-product-available')) || module.getAttribute('data-product-available') || '',
      variant_id: (selectorCard && selectorCard.getAttribute('data-variant-id')) || module.getAttribute('data-variant-id') || (variantInput && variantInput.value) || '',
      form_action: form && form.getAttribute ? form.getAttribute('action') || '' : '',
      cta_text: cta ? textOf(cta) : '',
      offer_exposure_id: module.getAttribute('data-an-offer-id') || '',
      guarantee_exposure_id: module.getAttribute('data-an-guarantee-id') || '',
      loyalty_exposure_id: module.getAttribute('data-an-loyalty-id') || '',
      review_exposure_id: module.getAttribute('data-an-review-id') || '',
      proof_exposure_id: module.getAttribute('data-an-proof-id') || '',
      is_system_selector_context: !!selector,
      is_selector_choice_context: !!selectorCard,
      is_product_module_context: true
    };
  }

  function ctaProps(target, extra) {
    var form = target && target.closest ? target.closest('form') : null;
    var variantInput = form && form.querySelector ? form.querySelector('[name="id"]') : null;
    var quantityInput = form && form.querySelector ? form.querySelector('[name="quantity"]') : null;
    return Object.assign({
      cta_id: stableCtaId(target),
      cta_slot: target && target.getAttribute ? target.getAttribute('data-an-cta-slot') || '' : '',
      cta_action: target && target.getAttribute ? target.getAttribute('data-an-cta-action') || '' : '',
      cta_text: textOf(target),
      cta_label_normalized: normalizedCtaLabel(target),
      cta_href: target && target.getAttribute ? safeUrl(target.getAttribute('href') || '') : '',
      cta_location: closestLabel(target),
      cta_tag: target && target.tagName ? target.tagName.toLowerCase() : '',
      target_href: target && target.getAttribute ? safeUrl(target.getAttribute('href') || '') : '',
      variant_id: (variantInput && variantInput.value) || (form && form.getAttribute ? form.getAttribute('data-lp-variant-id') || '' : ''),
      quantity: quantityInput && quantityInput.value ? Number(quantityInput.value) : 1,
      selected_product_path: form && form.getAttribute ? form.getAttribute('data-product-handle') || '' : '',
      form_action: form && form.getAttribute ? form.getAttribute('action') || '' : ''
    }, productModuleProps(target), extra || {});
  }

  function normalizedCtaLabel(element) {
    if (!element) return '';
    var accelerated = element.closest && element.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (accelerated || (element.tagName && element.tagName.toUpperCase().indexOf('SHOPIFY-ACCELERATED-CHECKOUT') === 0)) {
      return 'accelerated_checkout';
    }
    var label = textOf(element).toLowerCase();
    if (/add to (bag|cart)|begin reconstruction/.test(label)) return 'add_to_cart';
    if (/checkout|buy now/.test(label)) return 'checkout';
    if (/measured results|results|proof/.test(label)) return 'view_proof';
    return label.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 80);
  }

  function stableCtaId(element) {
    if (!element || !element.getAttribute) return '';
    var explicit = element.getAttribute('data-an-cta-id') || element.getAttribute('data-testid') || element.id;
    if (explicit) return String(explicit).slice(0, 160);
    var form = element.closest ? element.closest('form') : null;
    var module = element.closest ? element.closest('[data-an-product-module], [data-section-id], section[id]') : null;
    var moduleId = module && (module.getAttribute('data-an-module-id') || module.getAttribute('data-section-id') || module.id);
    var variant = form && form.querySelector ? form.querySelector('[name="id"]') : null;
    return [moduleId || closestLabel(element), normalizedCtaLabel(element), variant && variant.value].filter(Boolean).join(':').slice(0, 160);
  }

  function checkoutBehavior(form) {
    if (!form || !form.getAttribute) return '';
    try {
      if (window.AnatomyFunnelExperiments && typeof window.AnatomyFunnelExperiments.checkoutModeForForm === 'function') {
        var experimentMode = window.AnatomyFunnelExperiments.checkoutModeForForm(form);
        if (experimentMode === 'direct' || experimentMode === 'drawer') return experimentMode;
      }
    }
    catch (error) {}
    var declared = form.getAttribute('data-an-checkout-default') || '';
    if (declared === 'direct' || declared === 'drawer') return declared;
    return form.hasAttribute('data-lp-redirect') ? 'direct' : 'drawer';
  }

  function emailCaptureProps(element, extra) {
    var canonical = element && element.closest ? element.closest('[data-an-email-capture]') : null;
    if (!canonical && element && element.matches && element.matches('[data-an-email-capture]')) canonical = element;
    var host = canonical && canonical.querySelector ? canonical.querySelector('[data-klaviyo-form-id]') : null;
    return Object.assign({
      capture_id: canonical ? canonical.getAttribute('data-an-capture-id') || '' : '',
      capture_context: canonical ? canonical.getAttribute('data-an-capture-context') || '' : '',
      capture_trigger: canonical ? canonical.getAttribute('data-an-capture-trigger') || 'embedded_form' : '',
      capture_variant: canonical ? canonical.getAttribute('data-an-capture-variant') || 'default' : '',
      capture_step: canonical ? canonical.getAttribute('data-an-capture-step') || '' : '',
      capture_origin_path: canonical ? canonical.getAttribute('data-an-capture-origin') || window.location.pathname : window.location.pathname,
      capture_location: canonical ? closestLabel(canonical) : '',
      capture_text: canonical ? textOf(canonical).slice(0, 220) : '',
      klaviyo_form_id: host ? host.getAttribute('data-klaviyo-form-id') || '' : ''
    }, extra || {});
  }

  function productOfferProps(element) {
    return Object.assign({
      offer_state_location: closestLabel(element),
      offer_state_text_sample: textOf(element).slice(0, 220),
      visible_price_text: element && element.querySelector ? textOf(element.querySelector('.lp-bundle__price, .lp-selector-card__price, .price, [data-price]')) : ''
    }, productModuleProps(element));
  }

  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    }
    catch (error) {
      return null;
    }
  }

  function attrValue(attribution, touch, key) {
    if (!attribution) return '';
    if (attribution[key]) return attribution[key];
    if (attribution[touch] && attribution[touch][key]) return attribution[touch][key];
    return '';
  }

  function contextValue(attribution, key) {
    if (!attribution) return '';
    if (attribution[key]) return attribution[key];
    if (attribution.context && attribution.context[key]) return attribution.context[key];
    return '';
  }

  function sessionValue(session, key) {
    if (!session) return '';
    return session[key] || session['attribution_' + key] || '';
  }

  function normalizeSource(source, clickIds, referrer) {
    source = String(source || '').toLowerCase();
    referrer = String(referrer || '').toLowerCase();
    clickIds = clickIds || {};
    var evidence = source + ' ' + referrer;
    if (evidence.indexOf('facebook') !== -1 || evidence.indexOf('instagram') !== -1 || source === 'fb' || source === 'ig' || source === 'meta' || clickIds.fbclid) return 'meta';
    if (evidence.indexOf('tiktok') !== -1 || source === 'tt' || clickIds.ttclid) return 'tiktok';
    if (evidence.indexOf('google') !== -1 || source === 'adwords' || clickIds.gclid || clickIds.gbraid || clickIds.wbraid) return 'google';
    if (evidence.indexOf('pinterest') !== -1 || source === 'pin') return 'pinterest';
    if (evidence.indexOf('klaviyo') !== -1) return 'klaviyo';
    if (source) return source;
    return 'direct_or_unknown';
  }

  function attributionQuality(props) {
    if (props.last_utm_source || props.last_utm_campaign || props.last_utm_content) return 'utm';
    if (props.last_fbclid || props.last_gclid || props.last_gbraid || props.last_wbraid || props.last_ttclid || props.last_msclkid) return 'click_id';
    if (props.referrer || props.session_entry_referrer || props.last_referrer) return 'referrer';
    return 'direct_or_unknown';
  }

  function viewportProps() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    return {
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      screen_width: window.screen && window.screen.width,
      screen_height: window.screen && window.screen.height,
      device_pixel_ratio: window.devicePixelRatio || 1,
      connection_effective_type: connection.effectiveType || '',
      connection_save_data: !!connection.saveData
    };
  }

  function queryParams() {
    var params = {};
    try {
      var search = new URLSearchParams(window.location.search);
      var allowedKeys = marketingAllowed() ? MARKETING_QUERY_KEYS.slice() : [];
      if (advertisingAllowed()) allowedKeys = allowedKeys.concat(AD_QUERY_KEYS);
      allowedKeys.forEach(function (key) {
        var value = search.get(key);
        if (value) params[key] = value.slice(0, 300);
      });
    }
    catch (error) {}
    return params;
  }

  function detectOfferCode() {
    if (!analyticsAllowed() || !marketingAllowed()) return '';
    var code = '';
    try {
      var pathMatch = window.location.pathname.match(/\/discount\/([^\/\?#]+)/i);
      if (pathMatch && pathMatch[1]) code = decodeURIComponent(pathMatch[1]);
      if (!code) {
        var params = new URLSearchParams(window.location.search);
        code = params.get('discount') || params.get('offer') || '';
      }
      code = String(code || '').trim().slice(0, 80);
      if (code) window.sessionStorage.setItem('anatomy_offer_code_v1', code);
      if (!code) code = window.sessionStorage.getItem('anatomy_offer_code_v1') || '';
    }
    catch (error) {}
    return code;
  }

  function writeSessionJson(key, value) {
    if (!analyticsAllowed()) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value || {}));
    }
    catch (error) {}
  }

  function readSessionJson(key) {
    if (!analyticsAllowed()) return {};
    try {
      var value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : {};
    }
    catch (error) {
      return {};
    }
  }

  function funnelSessionId() {
    if (!analyticsAllowed()) return '';
    var state = readSessionJson(FUNNEL_SESSION_KEY);
    var now = Date.now();
    if (state.id && state.last_seen_at && now - Number(state.last_seen_at) < 30 * 60 * 1000) {
      state.last_seen_at = now;
      writeSessionJson(FUNNEL_SESSION_KEY, state);
      return state.id;
    }
    state = {
      id: 'fs_' + uuid(),
      started_at: new Date(now).toISOString(),
      last_seen_at: now
    };
    writeSessionJson(FUNNEL_SESSION_KEY, state);
    return state.id;
  }

  function browserState() {
    if (!analyticsAllowed()) {
      return {
        browser_first_seen_at: '',
        browser_visitor_state: 'unknown'
      };
    }
    var firstSeen = '';
    try {
      firstSeen = window.localStorage.getItem(BROWSER_FIRST_SEEN_KEY) || '';
      if (!firstSeen) {
        firstSeen = new Date().toISOString();
        window.localStorage.setItem(BROWSER_FIRST_SEEN_KEY, firstSeen);
      }
    }
    catch (error) {}
    return {
      browser_first_seen_at: firstSeen,
      browser_visitor_state: firstSeen && Date.now() - Date.parse(firstSeen) > 30 * 60 * 1000 ? 'returning' : 'new'
    };
  }

  function deviceProps() {
    var userAgent = navigator.userAgent || '';
    var platform = navigator.userAgentData && navigator.userAgentData.platform
      ? navigator.userAgentData.platform
      : navigator.platform || '';
    var browser = /Edg\//.test(userAgent) ? 'edge'
      : /OPR\//.test(userAgent) ? 'opera'
        : /Chrome\//.test(userAgent) ? 'chrome'
          : /Safari\//.test(userAgent) && !/Chrome\//.test(userAgent) ? 'safari'
            : /Firefox\//.test(userAgent) ? 'firefox'
              : 'other';
    var operatingSystem = /iPhone|iPad|iPod/.test(userAgent) ? 'ios'
      : /Android/.test(userAgent) ? 'android'
        : /Windows/.test(userAgent) ? 'windows'
          : /Mac OS X/.test(userAgent) ? 'macos'
            : /Linux/.test(userAgent) ? 'linux'
              : platform.toLowerCase() || 'other';
    return {
      device_type: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      browser_name: browser,
      operating_system: operatingSystem
    };
  }

  function experimentProps() {
    var assignments = window.AnatomyExperimentAssignments || {};
    var ids = Object.keys(assignments);
    var flagStates = window.AnatomyFunnelExperiments && window.AnatomyFunnelExperiments.states
      ? window.AnatomyFunnelExperiments.states
      : {};
    var protocolState = flagStates['anatomy-protocol-choice-v1'] || {};
    var checkoutState = flagStates['anatomy-checkout-path-v1'] || {};
    var props = {
      protocol_choice_experiment_variant: protocolState.variant || '',
      protocol_choice_experiment_is_qa_forced: !!protocolState.forced,
      checkout_path_experiment_variant: checkoutState.variant || '',
      checkout_path_experiment_is_qa_forced: !!checkoutState.forced,
      active_funnel_feature_flags: Object.keys(flagStates).filter(function (key) {
        return !!(flagStates[key] && flagStates[key].variant);
      })
    };
    if (ids.length) {
      var assignment = assignments[ids[0]];
      return Object.assign(props, {
        experiment_id: assignment.experiment_id || ids[0],
        experiment_version: assignment.version || '',
        experiment_phase: assignment.phase || '',
        experiment_variant: assignment.variant || '',
        experiment_bucket: assignment.bucket,
        experiment_assigned_at: assignment.assigned_at || '',
        experiment_is_qa_forced: !!assignment.is_qa_forced,
        experiment_analysis_eligible: !assignment.is_qa_forced
      });
    }
    if (protocolState.variant) {
      return Object.assign(props, {
        experiment_id: 'anatomy-protocol-choice-v1',
        experiment_version: '2026-07-26.1',
        experiment_phase: protocolState.forced ? 'qa_forced' : 'posthog_feature_flag',
        experiment_variant: protocolState.variant,
        experiment_assigned_at: protocolState.appliedAt || '',
        experiment_is_qa_forced: !!protocolState.forced,
        experiment_analysis_eligible: !protocolState.forced
      });
    }
    return props;
  }

  function cartContext() {
    return readSessionJson(CART_CONTEXT_KEY);
  }

  function normalizedEvent(name) {
    var aliases = {
      an_page_viewed: 'page_viewed',
      an_section_viewed: 'content_engaged',
      an_scroll_depth_reached: 'content_engaged',
      an_product_recommendation_seen: 'product_choice_exposed',
      an_system_selector_viewed: 'product_choice_exposed',
      an_product_selector_choice_viewed: 'product_choice_exposed',
      an_product_selector_choice_clicked: 'product_choice_selected',
      an_cta_clicked: 'commercial_action',
      an_checkout_cta_clicked: 'checkout_intent',
      an_product_purchase_form_submitted: 'purchase_form_submitted',
      an_add_to_cart_cta_visible: 'cart_cta_visible',
      an_add_to_cart_submitted: 'cart_add_submitted',
      an_cart_action_succeeded: 'cart_action_succeeded',
      an_cart_action_failed: 'cart_action_failed',
      an_checkout_intent_started: 'checkout_intent',
      an_cart_drawer_opened: 'cart_drawer_opened',
      an_cart_drawer_checkout_visible: 'checkout_cta_visible',
      an_cart_drawer_checkout_clicked: 'checkout_intent',
      an_checkout_redirect_started: 'checkout_redirect_started',
      an_experiment_assigned: 'experiment_assigned',
      an_experiment_exposed: 'experiment_exposed'
    };
    return aliases[name] || name;
  }

  function funnelStage(name) {
    if (/checkout/.test(name)) return 8;
    if (/cart|commercial_action|product_choice_selected|add_to_cart|purchase_form/.test(name)) return 7;
    if (/product_choice|content_engaged|recommendation|offer_state|review|guarantee|loyalty/.test(name)) return 6;
    if (/page_viewed|page_quality|scroll|section/.test(name)) return 5;
    if (/experiment/.test(name)) return 6;
    return undefined;
  }

  function updateCartContext(cart) {
    if (!cart || typeof cart !== 'object') return {};
    var items = Array.isArray(cart.items) ? cart.items : [];
    var state = {
      cart_token: cart.token || cart.cart_token || '',
      cart_value: typeof cart.total_price === 'number' ? cart.total_price / 100 : undefined,
      cart_currency: cart.currency || config.currency || '',
      cart_item_count: typeof cart.item_count === 'number' ? cart.item_count : items.reduce(function (sum, item) { return sum + (Number(item.quantity) || 0); }, 0),
      cart_product_ids: items.map(function (item) { return item.product_id; }).filter(Boolean),
      cart_product_handles: items.map(function (item) { return item.handle || (item.product && item.product.handle) || ''; }).filter(Boolean),
      cart_variant_ids: items.map(function (item) { return item.variant_id || item.id; }).filter(Boolean),
      cart_updated_at: new Date().toISOString()
    };
    writeSessionJson(CART_CONTEXT_KEY, state);
    return state;
  }

  function baseProps(extra) {
    var attribution = marketingAllowed() ? readJson(ATTRIBUTION_KEY) : {};
    var session = marketingAllowed() ? readSessionJson(SESSION_KEY) : {};
    var cart = cartContext();
    var props = Object.assign({
      schema_version: FUNNEL_SCHEMA_VERSION,
      anatomy_tracking_version: VERSION,
      anatomy_tracker_version_text: VERSION,
      anatomy_visitor_id: visitorId(),
      posthog_distinct_id: directDistinctId() || visitorId(),
      funnel_session_id: funnelSessionId(),
      posthog_session_id: directSessionId(),
      page_url: safeUrl(window.location.href),
      page_path: window.location.pathname,
      page_title: document.title,
      page_type: config.pageType || '',
      template_name: config.templateName || '',
      template_suffix: config.templateSuffix || '',
      canonical_url: config.canonicalUrl || '',
      referrer: marketingAllowed() ? safeUrl(document.referrer) : '',
      first_landing_url: attrValue(attribution, 'first', 'first_landing_url'),
      first_landing_path: attrValue(attribution, 'first', 'first_landing_path'),
      first_referrer: attrValue(attribution, 'first', 'first_referrer'),
      first_utm_source: attrValue(attribution, 'first', 'first_utm_source'),
      first_utm_medium: attrValue(attribution, 'first', 'first_utm_medium'),
      first_utm_campaign: attrValue(attribution, 'first', 'first_utm_campaign'),
      first_utm_content: attrValue(attribution, 'first', 'first_utm_content'),
      first_utm_term: attrValue(attribution, 'first', 'first_utm_term'),
      first_utm_placement: attrValue(attribution, 'first', 'first_utm_placement'),
      first_utm_site: attrValue(attribution, 'first', 'first_utm_site'),
      first_utm_id: attrValue(attribution, 'first', 'first_utm_id'),
      first_utm_adset_id: attrValue(attribution, 'first', 'first_utm_adset_id'),
      first_utm_ad_id: attrValue(attribution, 'first', 'first_utm_ad_id'),
      first_fbclid: attrValue(attribution, 'first', 'first_fbclid'),
      first_gclid: attrValue(attribution, 'first', 'first_gclid'),
      first_gbraid: attrValue(attribution, 'first', 'first_gbraid'),
      first_wbraid: attrValue(attribution, 'first', 'first_wbraid'),
      first_ttclid: attrValue(attribution, 'first', 'first_ttclid'),
      first_msclkid: attrValue(attribution, 'first', 'first_msclkid'),
      first_timestamp: attrValue(attribution, 'first', 'first_timestamp'),
      last_landing_url: attrValue(attribution, 'last', 'last_landing_url'),
      last_landing_path: attrValue(attribution, 'last', 'last_landing_path'),
      last_referrer: attrValue(attribution, 'last', 'last_referrer'),
      last_utm_source: attrValue(attribution, 'last', 'last_utm_source'),
      last_utm_medium: attrValue(attribution, 'last', 'last_utm_medium'),
      last_utm_campaign: attrValue(attribution, 'last', 'last_utm_campaign'),
      last_utm_content: attrValue(attribution, 'last', 'last_utm_content'),
      last_utm_term: attrValue(attribution, 'last', 'last_utm_term'),
      last_utm_placement: attrValue(attribution, 'last', 'last_utm_placement'),
      last_utm_site: attrValue(attribution, 'last', 'last_utm_site'),
      last_utm_id: attrValue(attribution, 'last', 'last_utm_id'),
      last_utm_adset_id: attrValue(attribution, 'last', 'last_utm_adset_id'),
      last_utm_ad_id: attrValue(attribution, 'last', 'last_utm_ad_id'),
      last_fbclid: attrValue(attribution, 'last', 'last_fbclid'),
      last_gclid: attrValue(attribution, 'last', 'last_gclid'),
      last_gbraid: attrValue(attribution, 'last', 'last_gbraid'),
      last_wbraid: attrValue(attribution, 'last', 'last_wbraid'),
      last_ttclid: attrValue(attribution, 'last', 'last_ttclid'),
      last_msclkid: attrValue(attribution, 'last', 'last_msclkid'),
      last_timestamp: attrValue(attribution, 'last', 'last_timestamp'),
      attribution_fbp: contextValue(attribution, 'attribution_fbp'),
      attribution_fbc: contextValue(attribution, 'attribution_fbc'),
      session_entry_url: sessionValue(session, 'session_entry_url'),
      session_entry_path: sessionValue(session, 'session_entry_path'),
      session_entry_referrer: sessionValue(session, 'session_referrer'),
      shop_domain: config.shopDomain || '',
      cart_token: cart.cart_token || '',
      cart_value: cart.cart_value,
      cart_currency: cart.cart_currency || config.currency || '',
      cart_item_count: cart.cart_item_count,
      cart_product_ids: cart.cart_product_ids || [],
      cart_product_handles: cart.cart_product_handles || [],
      cart_variant_ids: cart.cart_variant_ids || [],
      guarantee_exposure_id: document.querySelector('[data-an-guarantee-id]') ? document.querySelector('[data-an-guarantee-id]').getAttribute('data-an-guarantee-id') || '' : '',
      loyalty_exposure_id: document.querySelector('[data-an-loyalty-id]') ? document.querySelector('[data-an-loyalty-id]').getAttribute('data-an-loyalty-id') || '' : '',
      review_exposure_id: document.querySelector('[data-oke-reviews-widget], .okeReviews') ? 'onsite_reviews' : '',
      quiz_exposure_id: config.templateSuffix === 'quiz' || config.templateSuffix === 'quiz-results' ? 'hair_consultation_v1' : '',
      proof_exposure_id: document.querySelector('[data-an-proof-id], #measured-results') ? 'measured_results' : ''
    }, viewportProps(), browserState(), deviceProps(), experimentProps(), queryParams(), extra || {});

    props.active_offer_code = detectOfferCode();
    props.is_internal = IS_INTERNAL;
    props.is_automation = IS_AUTOMATION;

    var channels = channelProps(props);
    if (channels) {
      props.first_platform = channels.first.platform;
      props.first_channel = channels.first.channel;
      props.last_platform = channels.last.platform;
      props.last_channel = channels.last.channel;
      props.session_platform = channels.session.platform;
      props.session_channel = channels.session.channel;
      props.normalized_first_source = channels.legacySource(channels.first);
      props.normalized_last_source = channels.legacySource(channels.last);
      props.attribution_quality = attributionQuality(props);
      props.is_paid_traffic = channels.last.is_paid;
      return props;
    }

    // No marketing consent (every source field is empty, and the sanitizer
    // drops these properties from events) or no shared classifier.
    props.normalized_last_source = normalizeSource(props.last_utm_source || props.utm_source, {
      fbclid: props.last_fbclid || props.fbclid,
      gclid: props.last_gclid || props.gclid,
      gbraid: props.last_gbraid || props.gbraid,
      wbraid: props.last_wbraid || props.wbraid,
      ttclid: props.last_ttclid || props.ttclid
    }, props.last_referrer || props.session_entry_referrer || props.referrer);
    props.normalized_first_source = normalizeSource(props.first_utm_source, {
      fbclid: props.first_fbclid,
      gclid: props.first_gclid,
      gbraid: props.first_gbraid,
      wbraid: props.first_wbraid,
      ttclid: props.first_ttclid
    }, props.first_referrer);
    props.attribution_quality = attributionQuality(props);
    var lastMedium = String(props.last_utm_medium || '').toLowerCase().replace(/-/g, '_');
    var currentMedium = String(props.utm_medium || '').toLowerCase().replace(/-/g, '_');
    props.is_paid_traffic = lastMedium === 'paid_social'
      || lastMedium === 'cpc'
      || lastMedium === 'paid_search'
      || currentMedium === 'paid_social'
      || currentMedium === 'cpc'
      || currentMedium === 'paid_search'
      || !!(props.last_fbclid || props.last_gclid || props.last_gbraid || props.last_wbraid || props.last_ttclid || props.fbclid || props.gclid || props.gbraid || props.wbraid || props.ttclid);

    return props;
  }

  // Channel of the first touch, the last touch and this session, by the shared
  // classifier (window.AnatomyChannel, anatomy-attribution.js). The last touch
  // falls back to the current page only when nothing is stored for it.
  function channelProps(props) {
    var api = window.AnatomyChannel;
    if (!api || typeof api.classifyTouch !== 'function' || !marketingAllowed()) return null;
    var last = api.classifyTouch(props, 'last');
    if (last.platform === 'direct') {
      var current = api.classify({ landing_url: props.page_url, referrer: props.referrer });
      if (current.platform !== 'direct') last = current;
    }
    return {
      first: api.classifyTouch(props, 'first'),
      last: last,
      session: api.classify({ landing_url: props.session_entry_url, referrer: props.session_entry_referrer }),
      legacySource: api.legacySource
    };
  }

  function isMarketingProperty(key) {
    return /^(?:\$?(?:initial_)?utm_|\$?(?:initial_)?referr|first_|last_|session_entry_|session_channel$|session_platform$|normalized_(?:first|last)_source$|attribution_quality$|is_paid_traffic$|active_offer_code$|offer_code$|campaign_id$|adset_id$|ad_group_id$|adgroup_id$|ad_id$|creative_id$|sv1$)/i.test(key);
  }

  function isAdIdentifierProperty(key) {
    return /(?:^|_)(?:fbclid|gclid|gclsrc|dclid|gbraid|wbraid|gad_source|ttclid|twclid|li_fat_id|igshid|rdt_cid|qclid|sccid|msclkid|epik|irclid|kx|mc_cid|mc_eid|fbp|fbc|awc|sscid|lbclid|lb_hash|srsltid)(?:$|_)/i.test(key);
  }

  function sanitizePostHogValue(value, key, depth) {
    if (value === null || typeof value === 'undefined') return value;
    if (depth > 6) return typeof value === 'object' ? undefined : value;
    if (typeof value === 'string' && /(?:url|href|referrer)$/i.test(key)) return safeUrl(value);
    if (Array.isArray(value)) {
      return value.map(function (entry) {
        return sanitizePostHogValue(entry, key, depth + 1);
      });
    }
    if (typeof value !== 'object') return value;

    var clean = {};
    Object.keys(value).forEach(function (childKey) {
      if (!marketingAllowed() && isMarketingProperty(childKey)) return;
      if (!advertisingAllowed() && isAdIdentifierProperty(childKey)) return;
      clean[childKey] = sanitizePostHogValue(value[childKey], childKey, depth + 1);
    });
    return clean;
  }

  function sanitizePostHogEvent(event) {
    if (!analyticsAllowed()) return null;
    if (!event || typeof event !== 'object') return event;
    // rrweb snapshots are deeply nested structural payloads. Recursively
    // rewriting them corrupts replay trees, so record them only when the
    // complete marketing/advertising purpose gate is open and otherwise drop
    // the snapshot atomically.
    if (event.event === '$snapshot') {
      return marketingAllowed() && advertisingAllowed() ? event : null;
    }
    var clean = Object.assign({}, event);
    clean.properties = sanitizePostHogValue(event.properties || {}, 'properties', 0);
    if (event.event === '$exception') {
      classifyException(clean.properties);
      // Other parties' scripts, browser extensions and in-app webviews are
      // not ours to fix; only the storefront's own exceptions are sent.
      if (DROPPED_EXCEPTION_OWNERS[clean.properties.exception_owner]) return null;
    }
    return clean;
  }

  var DROPPED_EXCEPTION_OWNERS = {
    network_or_third_party: true,
    browser_or_extension: true,
    embedded_webview: true
  };

  function classifyException(properties) {
    if (!properties || typeof properties !== 'object') return;
    var sample = '';
    try { sample = JSON.stringify(properties.$exception_list || properties).slice(0, 6000); }
    catch (error) { sample = String(properties.$exception_message || ''); }
    var lower = sample.toLowerCase();
    var classification = {
      exception_owner: 'unknown',
      exception_fingerprint: 'unclassified',
      exception_actionability: 'review'
    };

    if (/klaviyo/.test(lower) && /experience|assign|500/.test(lower)) {
      classification = {
        exception_owner: 'third_party_klaviyo',
        exception_fingerprint: 'klaviyo_experience_assign_500',
        exception_actionability: 'provider_transient'
      };
    }
    else if (/_autofillcallbackhandler/.test(lower)) {
      classification = {
        exception_owner: 'browser_or_extension',
        exception_fingerprint: 'autofill_callback_bridge_missing',
        exception_actionability: 'non_storefront'
      };
    }
    else if (/webkit/.test(lower) && /messagehandlers/.test(lower)) {
      classification = {
        exception_owner: 'embedded_webview',
        exception_fingerprint: 'webkit_message_handler_missing',
        exception_actionability: 'host_bridge'
      };
    }
    else if (/resizeobserver loop/.test(lower)) {
      classification = {
        exception_owner: 'browser_or_extension',
        exception_fingerprint: 'resize_observer_loop',
        exception_actionability: 'non_storefront'
      };
    }
    else if (/"(?:value|\$exception_message)":"script error\.?"/.test(lower)) {
      // Our theme scripts are same-origin and report full errors; only a
      // cross-origin script is reduced to "Script error.".
      classification = {
        exception_owner: 'network_or_third_party',
        exception_fingerprint: 'cross_origin_script_error',
        exception_actionability: 'non_storefront'
      };
    }
    else if (/load failed|failed to fetch|networkerror|xmlhttprequest|xhr/.test(lower)) {
      // The fetch wrapper (bindNetworkOutcomes) is in the stack of every page
      // script's fetch and re-throws its failure, while this file's own
      // requests all catch theirs. A frame from this file therefore says
      // nothing about whose request failed: judge by the other frames.
      var callerSample = lower.replace(/"[^"]*anatomy-posthog[^"]*"/g, '""');
      classification = {
        exception_owner: /anatomy-quiz|anatomyhaircare\.com/.test(callerSample) ? 'anatomy_network' : 'network_or_third_party',
        exception_fingerprint: 'network_request_failed',
        exception_actionability: 'correlate_with_request'
      };
    }
    else if (/anatomy-posthog|anatomy-quiz|anatomyhaircare\.com/.test(lower)) {
      classification = {
        exception_owner: 'anatomy_storefront',
        exception_fingerprint: 'owned_javascript_exception',
        exception_actionability: 'investigate'
      };
    }

    Object.assign(properties, classification);
  }

  function sanitizeStoredPurposeState() {
    if (!marketingAllowed()) {
      [POSTHOG_CART_SYNC_KEY, CHECKOUT_INTENT_KEY, OFFER_SIGNAL_KEY, 'anatomy_offer_code_v1'].forEach(function (key) {
        removeStorage(window.sessionStorage, key);
      });
      return;
    }
    if (advertisingAllowed()) return;
    removeStorage(window.sessionStorage, POSTHOG_CART_SYNC_KEY);
    try {
      var intent = window.sessionStorage.getItem(CHECKOUT_INTENT_KEY);
      if (!intent) return;
      var parsed = JSON.parse(intent);
      ['checkout_intent_page_url', 'checkout_intent_referrer', 'checkout_intent_cta_href'].forEach(function (key) {
        if (parsed[key]) parsed[key] = safeUrl(parsed[key]);
      });
      window.sessionStorage.setItem(CHECKOUT_INTENT_KEY, JSON.stringify(parsed));
    }
    catch (error) {
      removeStorage(window.sessionStorage, CHECKOUT_INTENT_KEY);
    }
  }

  function putCartAttribute(attributes, key, value, length) {
    var clean = truncate(value, length || 700);
    if (!clean) return;
    attributes[key] = clean;
  }

  function buildCheckoutIntent(target, source) {
    target = target || null;
    var form = target && target.closest ? target.closest('form') : null;
    var variantInput = form && form.querySelector ? form.querySelector('[name="id"]') : null;
    var cart = cartContext();
    var previousIntent = readSessionJson(CHECKOUT_INTENT_KEY);
    var targetCtaId = stableCtaId(target);
    var now = Date.now();
    if (previousIntent.checkout_intent_id
      && previousIntent.checkout_intent_cta_id === targetCtaId
      && now - Number(previousIntent.checkout_intent_created_ms || 0) < 2000) {
      return previousIntent;
    }
    var intent = {
      checkout_intent_id: 'ci_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2),
      parent_checkout_intent_id: previousIntent.checkout_intent_id || '',
      checkout_intent_created_ms: now,
      checkout_intent_source: source || '',
      checkout_intent_started_at: new Date().toISOString(),
      checkout_intent_page_url: safeUrl(window.location.href),
      checkout_intent_page_path: window.location.pathname,
      checkout_intent_referrer: safeUrl(document.referrer),
      checkout_intent_cta_text: textOf(target),
      checkout_intent_cta_id: targetCtaId,
      checkout_intent_cta_slot: target && target.getAttribute ? target.getAttribute('data-an-cta-slot') || '' : '',
      checkout_intent_cta_action: target && target.getAttribute ? target.getAttribute('data-an-cta-action') || '' : '',
      checkout_intent_cta_label_normalized: normalizedCtaLabel(target),
      checkout_intent_cta_href: target && target.getAttribute ? safeUrl(target.getAttribute('href') || '') : '',
      checkout_intent_cta_location: closestLabel(target),
      checkout_intent_variant_id: form && form.getAttribute ? form.getAttribute('data-lp-variant-id') || '' : '',
      checkout_intent_form_action: form && form.getAttribute ? form.getAttribute('action') || '' : '',
      checkout_behavior: checkoutBehavior(form),
      protocol_choice_experiment_variant: experimentProps().protocol_choice_experiment_variant || '',
      checkout_path_experiment_variant: experimentProps().checkout_path_experiment_variant || '',
      checkout_token: cart.cart_token || '',
      value: cart.cart_value,
      currency: cart.cart_currency || config.currency || '',
      content_ids: cart.cart_variant_ids || [],
      product_ids: cart.cart_product_ids || [],
      item_count: cart.cart_item_count
    };
    if (!intent.checkout_intent_variant_id && variantInput) intent.checkout_intent_variant_id = variantInput.value || '';
    writeSessionJson(CHECKOUT_INTENT_KEY, intent);
    return intent;
  }

  function checkoutProvider(target, isAccelerated, href) {
    var sample = (textOf(target) + ' ' + String(href || '')).toLowerCase();
    if (/shop\s*pay/.test(sample)) return 'shop_pay';
    if (/apple\s*pay/.test(sample)) return 'apple_pay';
    if (/google\s*pay|gpay/.test(sample)) return 'google_pay';
    if (/paypal/.test(sample)) return 'paypal';
    return isAccelerated ? 'accelerated_unknown' : 'shopify_checkout';
  }

  function recordCheckoutHandoff(intent, target, isAccelerated, href) {
    if (!intent || !intent.checkout_intent_id) return;
    var handoff = {
      checkout_intent_id: intent.checkout_intent_id,
      handoff_type: isAccelerated ? 'accelerated_checkout' : 'shopify_checkout',
      handoff_provider: checkoutProvider(target, isAccelerated, href),
      handoff_started_at: new Date().toISOString(),
      handoff_started_ms: Date.now(),
      handoff_origin_path: window.location.pathname,
      handoff_origin_url: marketingAllowed()
        ? safeUrl(window.location.href)
        : window.location.origin + window.location.pathname
    };
    writeSessionJson(CHECKOUT_HANDOFF_KEY, handoff);
    capture('an_external_checkout_handoff_started', handoff, UNLOAD_SAFE_CAPTURE);
  }

  function captureReturnedCheckoutHandoff(reason) {
    var handoff = readSessionJson(CHECKOUT_HANDOFF_KEY);
    var startedMs = Number(handoff.handoff_started_ms || 0);
    if (!handoff.checkout_intent_id || !startedMs || Date.now() - startedMs < 2000) return;
    var elapsed = Date.now() - startedMs;
    capture('an_external_checkout_returned_to_storefront', {
      checkout_intent_id: handoff.checkout_intent_id,
      handoff_type: handoff.handoff_type || '',
      handoff_provider: handoff.handoff_provider || '',
      handoff_origin_path: handoff.handoff_origin_path || '',
      handoff_elapsed_ms: elapsed,
      handoff_return_reason: reason || 'page_show',
      handoff_completed_status: 'unknown'
    });
    removeStorage(window.sessionStorage, CHECKOUT_HANDOFF_KEY);
  }

  function bindCheckoutHandoffReturns() {
    window.addEventListener('pageshow', function (event) {
      captureReturnedCheckoutHandoff(event.persisted ? 'back_forward_cache' : 'page_show');
    });
    window.setTimeout(function () {
      captureReturnedCheckoutHandoff('storefront_reload');
    }, 500);
  }

  function buildCartAttributes(extra) {
    var props = baseProps(extra || {});
    var intent = sanitizePostHogValue(readSessionJson(CHECKOUT_INTENT_KEY), 'checkout_intent', 0);
    var attributes = {};

    putCartAttribute(attributes, 'attribution_anatomy_visitor_id', props.anatomy_visitor_id, 300);
    putCartAttribute(attributes, 'attribution_posthog_distinct_id', props.posthog_distinct_id || props.anatomy_visitor_id, 300);
    putCartAttribute(attributes, 'attribution_posthog_session_id', props.posthog_session_id || directSessionId(), 300);
    putCartAttribute(attributes, 'attribution_schema_version', props.schema_version, 80);
    putCartAttribute(attributes, 'attribution_funnel_session_id', props.funnel_session_id, 300);
    putCartAttribute(attributes, 'attribution_cart_token', props.cart_token, 300);

    [
      'experiment_id',
      'experiment_version',
      'experiment_phase',
      'experiment_variant',
      'experiment_bucket',
      'experiment_assigned_at',
      'experiment_is_qa_forced'
    ].forEach(function (key) {
      putCartAttribute(attributes, 'attribution_' + key, props[key], 300);
    });

    putCartAttribute(attributes, 'attribution_protocol_choice_experiment_variant', props.protocol_choice_experiment_variant, 80);
    putCartAttribute(attributes, 'attribution_checkout_path_experiment_variant', props.checkout_path_experiment_variant, 80);
    putCartAttribute(attributes, 'attribution_protocol_choice_experiment_is_qa_forced', props.protocol_choice_experiment_is_qa_forced ? 'true' : 'false', 20);
    putCartAttribute(attributes, 'attribution_checkout_path_experiment_is_qa_forced', props.checkout_path_experiment_is_qa_forced ? 'true' : 'false', 20);

    [
      'first_landing_url',
      'first_landing_path',
      'first_referrer',
      'first_utm_source',
      'first_utm_medium',
      'first_utm_campaign',
      'first_utm_content',
      'first_utm_term',
      'first_utm_placement',
      'first_utm_site',
      'first_utm_id',
      'first_utm_adset_id',
      'first_utm_ad_id',
      'first_fbclid',
      'first_gclid',
      'first_gbraid',
      'first_wbraid',
      'first_ttclid',
      'first_msclkid',
      'first_timestamp',
      'last_landing_url',
      'last_landing_path',
      'last_referrer',
      'last_utm_source',
      'last_utm_medium',
      'last_utm_campaign',
      'last_utm_content',
      'last_utm_term',
      'last_utm_placement',
      'last_utm_site',
      'last_utm_id',
      'last_utm_adset_id',
      'last_utm_ad_id',
      'last_fbclid',
      'last_gclid',
      'last_gbraid',
      'last_wbraid',
      'last_ttclid',
      'last_msclkid',
      'last_timestamp'
    ].forEach(function (key) {
      putCartAttribute(attributes, 'attribution_' + key, props[key], key.indexOf('url') !== -1 ? 700 : 300);
    });

    putCartAttribute(attributes, 'attribution_fbp', props.attribution_fbp, 300);
    putCartAttribute(attributes, 'attribution_fbc', props.attribution_fbc, 350);
    putCartAttribute(attributes, 'attribution_session_entry_url', props.session_entry_url, 700);
    putCartAttribute(attributes, 'attribution_session_entry_path', props.session_entry_path, 350);
    putCartAttribute(attributes, 'attribution_session_referrer', props.session_entry_referrer, 500);
    putCartAttribute(attributes, 'attribution_normalized_first_source', props.normalized_first_source, 80);
    putCartAttribute(attributes, 'attribution_normalized_last_source', props.normalized_last_source, 80);
    putCartAttribute(attributes, 'attribution_first_channel', props.first_channel, 40);
    putCartAttribute(attributes, 'attribution_first_platform', props.first_platform, 200);
    putCartAttribute(attributes, 'attribution_last_channel', props.last_channel, 40);
    putCartAttribute(attributes, 'attribution_last_platform', props.last_platform, 200);
    putCartAttribute(attributes, 'attribution_quality', props.attribution_quality, 80);
    putCartAttribute(attributes, 'attribution_is_paid_traffic', props.is_paid_traffic ? 'true' : 'false', 20);
    putCartAttribute(attributes, 'attribution_current_page_url', props.page_url, 700);
    putCartAttribute(attributes, 'attribution_current_page_path', props.page_path, 350);

    if (props.active_offer_code) {
      putCartAttribute(attributes, 'attribution_offer_code', props.active_offer_code, 120);
      putCartAttribute(attributes, 'attribution_active_offer_code', props.active_offer_code, 120);
    }

    [
      'checkout_intent_id',
      'checkout_intent_source',
      'checkout_intent_started_at',
      'parent_checkout_intent_id',
      'checkout_intent_page_url',
      'checkout_intent_page_path',
      'checkout_intent_referrer',
      'checkout_intent_cta_text',
      'checkout_intent_cta_id',
      'checkout_intent_cta_slot',
      'checkout_intent_cta_action',
      'checkout_intent_cta_label_normalized',
      'checkout_intent_cta_href',
      'checkout_intent_cta_location',
      'checkout_intent_variant_id',
      'checkout_intent_form_action',
      'checkout_behavior'
    ].forEach(function (key) {
      putCartAttribute(attributes, 'attribution_' + key, intent[key], key.indexOf('url') !== -1 || key.indexOf('href') !== -1 ? 700 : 300);
    });

    return attributes;
  }

  // `options` is posthog-js CaptureOptions. It matters for events fired from a
  // control that navigates away (see UNLOAD_SAFE_CAPTURE): without it the
  // event sits in the SDK's queue and dies with the document. Unknown keys are
  // ignored by the SDK, so passing it is safe across versions.
  function capture(name, props, options) {
    if (!analyticsAllowed()) return;
    var properties = baseProps(props);
    properties.event_name_original = name;
    properties.event_name_normalized = normalizedEvent(name);
    properties.funnel_stage = funnelStage(properties.event_name_normalized);
    updateFunnelState(name, properties);
    var sessionId = directSessionId();
    // Keep our own copy for the cart-attribute sync + reporting; in the preferred
    // path below the SDK sets the canonical $session_id itself.
    if (sessionId) properties.posthog_session_id = sessionId;
    var consentEvent = sanitizePostHogEvent({ event: name, properties: properties });
    if (!consentEvent) return;
    properties = consentEvent.properties;

    // Preferred path: hand the event to posthog-js. The SDK owns distinct_id, so
    // it stays consistent across the anonymous→identified transition instead of
    // being pinned to anatomy_visitor_id (which would fragment a person's events
    // once they identify). It also attaches $session_id, $lib, $os, $browser,
    // $device_type and runs person processing — none of which a raw /capture/
    // POST gets. The array.js stub queues calls until the SDK loads, and the
    // first-party proxy makes that load reliable.
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(name, properties, options);
      return;
    }

    // Fallback only if the SDK object is absent (e.g. an event fired before the
    // array.js stub is installed): raw /capture/ with our managed ids.
    if (sessionId) properties.$session_id = sessionId;
    properties.$current_url = properties.page_url;
    properties.$pathname = properties.page_path;

    var body = JSON.stringify({
      api_key: config.projectKey,
      event: name,
      distinct_id: properties.anatomy_visitor_id,
      properties: properties,
      timestamp: new Date().toISOString()
    });

    fetch(config.apiHost.replace(/\/$/, '') + '/capture/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      keepalive: body.length < 60000
    }).catch(function () {});
  }

  function updateFunnelState(name, properties) {
    var stage = Number(properties && properties.funnel_stage) || 0;
    if (!stage) return;
    var state = readJson(FUNNEL_STATE_KEY);
    if (stage >= Number(state.highest_stage || 0)) {
      state.highest_stage = stage;
      state.highest_event = name;
      state.highest_event_at = new Date().toISOString();
    }
    var productHandle = properties.product_handle
      || (properties.cart_product_handles && properties.cart_product_handles[0])
      || '';
    if (productHandle) state.last_product_handle = productHandle;
    if (properties.selector_choice) state.protocol_interest = properties.selector_choice;
    state.last_page_path = window.location.pathname;
    try {
      window.localStorage.setItem(FUNNEL_STATE_KEY, JSON.stringify(state));
    }
    catch (error) {}
  }

  function navigationTimingProps() {
    var props = {
      page_quality_reason: '',
      document_visibility_state: document.visibilityState || '',
      lcp_ms: Math.round(largestContentfulPaintMs || 0),
      resource_count: window.performance && performance.getEntriesByType ? performance.getEntriesByType('resource').length : 0
    };
    if (!window.performance) return props;

    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav) {
        props.navigation_type = nav.type || '';
        props.redirect_count = nav.redirectCount || 0;
        props.time_to_first_byte_ms = Math.round(nav.responseStart || 0);
        props.dom_content_loaded_ms = Math.round(nav.domContentLoadedEventEnd || 0);
        props.load_event_end_ms = Math.round(nav.loadEventEnd || 0);
        props.transfer_size = nav.transferSize || 0;
        props.encoded_body_size = nav.encodedBodySize || 0;
        props.decoded_body_size = nav.decodedBodySize || 0;
        return props;
      }

      var timing = performance.timing || {};
      if (timing.navigationStart) {
        props.time_to_first_byte_ms = Math.max(0, timing.responseStart - timing.navigationStart);
        props.dom_content_loaded_ms = Math.max(0, timing.domContentLoadedEventEnd - timing.navigationStart);
        props.load_event_end_ms = Math.max(0, timing.loadEventEnd - timing.navigationStart);
      }
    }
    catch (error) {}
    return props;
  }

  function capturePageQuality(reason) {
    if (pageQualityCaptured || !analyticsAllowed()) return;
    pageQualityCaptured = true;
    var props = navigationTimingProps();
    props.page_quality_reason = reason || 'scheduled';
    capture('an_page_quality_measured', props);
  }

  function cartUpdateUrl() {
    var route = window.theme && window.theme.routes && window.theme.routes.cart_update_url
      ? window.theme.routes.cart_update_url
      : '/cart/update';

    if (/\.js(?:\?|$)/.test(route)) return route;
    return route.replace(/\/$/, '') + '.js';
  }

  function privacyReconciliationAttributes() {
    var attributes = analyticsAllowed()
      ? buildCartAttributes({ cart_sync_reason: 'privacy_consent_reconcile' })
      : {};
    var keysToClear = [];

    if (!analyticsAllowed()) {
      keysToClear = ALL_TRACKING_CART_ATTRIBUTE_KEYS;
    }
    else if (!marketingAllowed()) {
      keysToClear = MARKETING_CART_ATTRIBUTE_KEYS;
    }
    else if (!advertisingAllowed()) {
      keysToClear = AD_CART_ATTRIBUTE_KEYS;
    }
    else {
      return null;
    }

    keysToClear.forEach(function (key) {
      attributes[key] = '';
    });
    return attributes;
  }

  function reconcileCartAttributesForPrivacy() {
    var attributes = privacyReconciliationAttributes();
    if (!attributes) return Promise.resolve(false);

    var body = JSON.stringify({ attributes: attributes });
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        [CART_ATTRIBUTION_SYNC_HEADER]: '1'
      },
      credentials: 'same-origin',
      body: body,
      keepalive: body.length < 60000
    }).then(function (response) {
      return !!response.ok;
    }).catch(function () {
      return false;
    });
  }

  // Attributes that move with the page or the clock rather than with the
  // visitor's attribution: the current page, attribution_quality (it reads the
  // current page's referrer), timestamps, and the session ids that roll over
  // after 30 idle minutes. They are still written; they just do not make a
  // cart write necessary.
  var CART_SYNC_VOLATILE_KEYS = {
    attribution_current_page_url: true,
    attribution_current_page_path: true,
    attribution_quality: true,
    attribution_posthog_session_id: true,
    attribution_funnel_session_id: true
  };

  function cartSyncSignature(attributes) {
    var stable = {};
    Object.keys(attributes || {}).sort().forEach(function (key) {
      if (CART_SYNC_VOLATILE_KEYS[key] || /_(?:timestamp|started_at|assigned_at)$/.test(key)) return;
      stable[key] = attributes[key];
    });
    return JSON.stringify(stable);
  }

  function lastCartSyncSignature() {
    try {
      return window.sessionStorage.getItem(POSTHOG_CART_SYNC_KEY) || '';
    }
    catch (error) {
      return '';
    }
  }

  // `force` writes even when the signature matches the last successful write.
  // Checkout intents and cart mutations force it: the cart they act on may not
  // be the one this tab last wrote (a cart created by the add itself, or a new
  // cart after an order), and the order only carries what that cart holds.
  function syncPostHogCartAttributes(reason, keepalive, force) {
    if (!analyticsAllowed()) return Promise.resolve(false);
    var distinctId = visitorId();
    if (!distinctId) return Promise.resolve(false);

    var attributes = buildCartAttributes({
      cart_sync_reason: reason || ''
    });

    var signature = cartSyncSignature(attributes);
    if (!force && lastCartSyncSignature() === signature) return Promise.resolve(false);
    return writeCartAttributes(reason, attributes, signature, keepalive);
  }

  // A page view writes the cart only if the attribution changed since the last
  // successful write, or if the cart holds items (it may be a cart this tab
  // never wrote). That still covers checkouts that start without a click we
  // observe (express and accelerated paths), without a write on every page.
  function syncCartAttributesOnPageLoad() {
    if (!analyticsAllowed() || !visitorId()) return Promise.resolve(false);
    var attributes = buildCartAttributes({ cart_sync_reason: 'page_load' });
    var signature = cartSyncSignature(attributes);
    if (lastCartSyncSignature() !== signature) {
      return writeCartAttributes('page_load', attributes, signature, false);
    }
    return cartItemCount().then(function (count) {
      if (!(count > 0) || !analyticsAllowed()) return false;
      return writeCartAttributes('page_load', attributes, signature, false);
    });
  }

  // The item count Liquid rendered into the page config; /cart.js only when the
  // page did not carry one.
  function cartItemCount() {
    var rendered = config.cartItemCount;
    if (typeof rendered === 'number' && isFinite(rendered)) return Promise.resolve(rendered);
    return refreshCartContext().then(function (context) {
      return Number(context && context.cart_item_count) || 0;
    });
  }

  var cartAttributeWriteQueue = Promise.resolve();

  function writeCartAttributes(reason, attributes, signature, keepalive) {
    var operation = cartAttributeWriteQueue.then(function () {
      if (!analyticsAllowed()) return false;
      attributes = buildCartAttributes({ cart_sync_reason: reason || '' });
      signature = cartSyncSignature(attributes);
      return performCartAttributeWrite(reason, attributes, signature, keepalive, 0);
    });
    cartAttributeWriteQueue = operation.catch(function () { return false; });
    return operation.then(function (context) {
      if (!context) return false;
      if (reason !== 'cart_token_bridge' && context.cart_token && attributes.attribution_cart_token !== context.cart_token) {
        return syncPostHogCartAttributes('cart_token_bridge', keepalive).then(function (synced) {
          return synced || lastCartSyncSignature() === cartSyncSignature(buildCartAttributes({}));
        });
      }
      return true;
    });
  }

  function performCartAttributeWrite(reason, attributes, signature, keepalive, attempt) {
    var body = JSON.stringify({ attributes: attributes });
    var options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        [CART_ATTRIBUTION_SYNC_HEADER]: '1'
      },
      credentials: 'same-origin',
      body: body
    };
    if (keepalive && body.length < 60000) options.keepalive = true;

    return fetch(cartUpdateUrl(), options)
      .then(function (response) {
        if (!analyticsAllowed()) return false;
        if (!response.ok) {
          var failure = new Error('Cart attribution update failed');
          failure.status = response.status;
          throw failure;
        }
        var parsed = response.clone && typeof response.clone === 'function'
          ? response.clone().json().catch(function () { return null; })
          : Promise.resolve(null);
        return parsed.then(function (cart) {
          if (!analyticsAllowed()) return false;
          // Success is not captured: it fired on every page view (15% of all
          // events). Failures above still are.
          var context = updateCartContext(cart);
          try {
            window.sessionStorage.setItem(POSTHOG_CART_SYNC_KEY, signature);
          }
          catch (error) {}
          if (attempt > 0) {
            capture('an_cart_attribution_sync_recovered', {
              cart_sync_reason: reason || '', cart_sync_attempts: attempt + 1
            });
          }
          return context;
        });
      })
      .catch(function (error) {
        if (!analyticsAllowed()) return false;
        var retryable = !error.status || error.status === 408 || error.status >= 500;
        if (retryable && attempt < 2 && navigator.onLine !== false) {
          return new Promise(function (resolve) { setTimeout(resolve, 300 * (attempt + 1)); }).then(function () {
            if (!analyticsAllowed()) return false;
            var currentAttributes = buildCartAttributes({ cart_sync_reason: reason || '' });
            return performCartAttributeWrite(reason, currentAttributes, cartSyncSignature(currentAttributes), keepalive, attempt + 1);
          });
        }
        capture('an_cart_attribution_sync_failed', {
          cart_sync_reason: reason || '',
          cart_sync_error: error.status ? 'http_error' : 'network_error',
          cart_sync_status: error.status || 0,
          cart_sync_attempts: attempt + 1,
          cart_sync_attribute_count: Object.keys(attributes).length
        });
        return false;
      });
  }

  function loadPostHog() {
    var id = visitorId();
    writeVisitorCookie(id);

    window.posthog = window.posthog || [];
    if (!window.posthog.__SV) {
      var script = document.createElement('script');
      script.async = true;
      script.src = config.apiHost.replace(/\/$/, '') + '/static/array.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      window.posthog._i = [];
      window.posthog.init = function (token, options, name) {
        function factory(method) {
          return function () {
            window.posthog.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var methods = 'capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset get_distinct_id get_session_id isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group resetGroups setPersonPropertiesForFlags'.split(' ');
        var instance = window.posthog;
        if (name) {
          instance = window.posthog[name] = [];
        }
        instance.people = instance.people || [];
        methods.forEach(function (method) {
          var target = method.indexOf('people.') === 0 ? instance.people : instance;
          target[method.replace('people.', '')] = factory(method);
        });
        window.posthog._i.push([token, options, name]);
      };
      window.posthog.__SV = 1;
    }

    window.posthog.init(config.projectKey, {
      api_host: config.apiHost,
      ui_host: config.uiHost || 'https://us.posthog.com',
      // Multi-page storefront (full page loads, not an SPA): 'history_change'
      // only fires $pageview on history-API navigations, so the on-load pageview
      // was never captured (~6 $pageview/week vs ~1,356 real page loads), starving
      // PostHog Web Analytics, sessions, paths and bounce. `true` captures a
      // $pageview on every full page load — correct for this storefront.
      capture_pageview: false,
      capture_pageleave: true,
      // Narrow autocapture: clicks on the controls that have no custom event
      // (FAQ summaries, review "read more", carousel arrows, menu) plus CTAs.
      // posthog-js applies the same allowlists to $rageclick, so rage clicks
      // are recorded on these controls only; dead clicks are detected on any
      // element.
      autocapture: {
        dom_event_allowlist: ['click'],
        element_allowlist: ['a', 'button', 'summary'],
        css_selector_allowlist: [
          '[data-an-cta-id]',
          'summary',
          '.oke-readMore',
          '.oke-reviewContent-readMore',
          '[aria-label="Next"]',
          '[aria-label="Previous"]',
          '.menu-drawer-button',
          '.drawer__menu-item'
        ]
      },
      rageclick: true,
      capture_dead_clicks: true,
      save_campaign_params: false,
      store_google: false,
      save_referrer: false,
      capture_performance: { web_vitals: true },
      capture_exceptions: {
        capture_unhandled_errors: true,
        capture_unhandled_rejections: true
      },
      person_profiles: 'identified_only',
      before_send: sanitizePostHogEvent,
      bootstrap: {
        distinctID: id,
        isIdentifiedID: false
      },
      disable_session_recording: config.sessionRecording === false,
      session_recording: {
        // Protect every customer-entered value in session replay.
        maskAllInputs: true,
        maskInputOptions: { password: true }
      },
      loaded: function (instance) {
        if (!analyticsAllowed()) {
          try {
            if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
              window.posthog.opt_out_capturing({ clear_persistence: true });
            }
          }
          catch (error) {}
          return;
        }
        synchronizeVisitorIdWithPostHog();
        registerTrafficFlags(instance);
        capture('$pageview', {
          $current_url: safeUrl(window.location.href),
          $pathname: window.location.pathname,
          $referrer: marketingAllowed() ? safeUrl(document.referrer) : ''
        });
        capture('an_page_viewed', {
          product_id: config.product && config.product.id,
          product_handle: config.product && config.product.handle,
          product_title: config.product && config.product.title,
          product_price: config.product && config.product.price,
          product_available: config.product && config.product.available,
          collection_handle: config.collection && config.collection.handle
        });
        // Page-load cart write, only when the attribution changed or the cart
        // holds items (see syncCartAttributesOnPageLoad). Keeps accelerated /
        // dynamic / express checkouts that skip the click+submit sync triggers
        // carrying attribution into the order.
        try { syncCartAttributesOnPageLoad(); } catch (e) {}
      }
    });
  }

  // is_internal / is_automation as super properties, so they also reach events
  // the SDK captures itself ($autocapture, $rageclick, $dead_click, $exception,
  // $pageleave, $web_vitals). Called again after every posthog.reset(), which
  // clears super properties.
  function registerTrafficFlags(instance) {
    if (!analyticsAllowed()) return;
    var client = instance && typeof instance.register === 'function' ? instance : window.posthog;
    if (!client) return;
    try {
      if (typeof client.register === 'function') {
        client.register({ is_internal: IS_INTERNAL, is_automation: IS_AUTOMATION });
      }
      if (IS_INTERNAL && typeof client.setPersonProperties === 'function') {
        client.setPersonProperties({ $internal_or_test_user: true });
      }
    }
    catch (error) {}
  }

  function bindClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('a, button, input[type="submit"], [role="button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
        : null;
      if (!target) return;
      var href = target.getAttribute('href') || '';
      var label = textOf(target);
      var hashTarget = targetFromHash(href);
      var isHeroProductScroll = !!hashTarget
        && target.closest('.lp-angle-hero-section')
        && hashTarget.matches('[data-an-product-module]');
      var isAccelerated = !!target.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
        || (target.tagName && target.tagName.toUpperCase().indexOf('SHOPIFY-ACCELERATED-CHECKOUT') === 0);
      var productForm = target.closest('form[action*="/cart/add"], [data-lp-checkout-form], .product-form, .lp-checkout-form');
      var productCheckoutBehavior = productForm ? checkoutBehavior(productForm) : '';
      var isCheckout = /\/checkout(?:\/|\?|$)/.test(href)
        || target.getAttribute('name') === 'checkout'
        || productCheckoutBehavior === 'direct'
        || isAccelerated;
      var isProductCta = !!productForm;
      var selectorCard = target.closest('[data-an-selector-card]');
      var intent = (isCheckout || isProductCta)
        ? buildCheckoutIntent(target, isCheckout ? 'checkout_cta_click' : 'cart_add_cta_click')
        : {};
      capture(isCheckout ? 'an_checkout_cta_clicked' : 'an_cta_clicked', ctaProps(target, {
        is_product_cta: isProductCta,
        is_checkout_cta: isCheckout,
        checkout_behavior: productCheckoutBehavior,
        checkout_intent_id: intent.checkout_intent_id || ''
      }), UNLOAD_SAFE_CAPTURE);
      if (selectorCard) {
        capture('an_product_selector_choice_clicked', Object.assign(productModuleProps(selectorCard), ctaProps(target), {
          selector_action: isCheckout ? 'direct_checkout' : (isProductCta ? 'add_to_cart_drawer' : (href ? 'product_link' : 'button')),
          selector_choice: selectorCard.getAttribute('data-selector-choice') || '',
          selector_role: selectorCard.getAttribute('data-selector-role') || ''
        }), UNLOAD_SAFE_CAPTURE);
      }
      var cartCrossSell = target.closest('[data-an-cart-cross-sell]');
      if (cartCrossSell) {
        capture('an_cart_cross_sell_clicked', ctaProps(target, {
          cross_sell_id: cartCrossSell.getAttribute('data-an-cart-cross-sell') || '',
          cross_sell_products: (cartCrossSell.getAttribute('data-an-cross-sell-products') || '').split(',').filter(Boolean),
          cart_routine_count: Number(cartCrossSell.getAttribute('data-an-cart-routine-count') || 0)
        }), UNLOAD_SAFE_CAPTURE);
      }
      if (isCheckout) {
        capture('an_checkout_intent_started', intent, UNLOAD_SAFE_CAPTURE);
        recordCheckoutHandoff(intent, target, isAccelerated, href);
        syncPostHogCartAttributes('checkout_click', true, true).then(function (synced) {
          capture('an_checkout_intent_cart_sync_completed', {
            checkout_intent_id: intent.checkout_intent_id || '',
            cart_sync_succeeded: !!synced
          });
        });
      }
      if (isHeroProductScroll) {
        capture('an_product_module_scroll_clicked', Object.assign(ctaProps(target), {
          cta_text: label,
          cta_href: href,
          cta_location: closestLabel(target),
          scroll_target_hash: href,
          scroll_target_found: true
        }, productModuleProps(hashTarget)));
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      var action = form.getAttribute('action') || '';
      if (form.matches('[data-lp-checkout-form]')) {
        var button = form.querySelector('button[type="submit"], input[type="submit"]');
        var behavior = checkoutBehavior(form);
        var formIntent = buildCheckoutIntent(button || form, behavior + '_product_submit');
        syncPostHogCartAttributes(behavior + '_product_submit', true, true);
        var formProps = Object.assign({
          form_action: action,
          variant_id: form.getAttribute('data-lp-variant-id') || '',
          checkout_behavior: behavior,
          checkout_experiment_id: form.getAttribute('data-an-checkout-experiment') || '',
          checkout_intent_id: formIntent.checkout_intent_id || ''
        }, productModuleProps(form), ctaProps(button || form));
        capture('an_product_purchase_form_submitted', formProps, UNLOAD_SAFE_CAPTURE);
        capture(behavior === 'direct' ? 'an_direct_checkout_submitted' : 'an_add_to_cart_submitted', formProps, UNLOAD_SAFE_CAPTURE);
        return;
      }
      // Email-capture submits are observed via the native `klaviyoForms` event
      // (bindKlaviyoForms), not a theme submit handler — Klaviyo embeds submit
      // inside their own frame. The old [data-an-lead-capture-form] handler never
      // matched the live Klaviyo markup and is removed.
      if (/\/cart\/add/.test(action) || form.querySelector('[name="id"]')) {
        var cartButton = form.querySelector('button[type="submit"], input[type="submit"]');
        var cartIntent = buildCheckoutIntent(cartButton || form, 'cart_add_submit');
        syncPostHogCartAttributes('cart_add_submit', true, true);
        capture('an_add_to_cart_submitted', Object.assign({
          form_action: action,
          variant_id: (form.querySelector('[name="id"]') || {}).value || '',
          checkout_intent_id: cartIntent.checkout_intent_id || ''
        }, productModuleProps(form)));
      }
    }, true);
  }

  function cartDrawerProps(drawer, extra) {
    var intent = readSessionJson(CHECKOUT_INTENT_KEY);
    var cart = cartContext();
    var checkout = drawer && drawer.querySelector
      ? drawer.querySelector('[data-an-cart-drawer-action="checkout"]')
      : null;
    return Object.assign({
      cart_drawer_id: drawer && drawer.id ? drawer.id : 'CartDrawer',
      checkout_intent_id: intent.checkout_intent_id || '',
      parent_checkout_intent_id: intent.parent_checkout_intent_id || '',
      checkout_intent_source: intent.checkout_intent_source || '',
      originating_cta_id: intent.checkout_intent_cta_id || '',
      originating_cta_slot: intent.checkout_intent_cta_slot || '',
      originating_page_path: intent.checkout_intent_page_path || '',
      cart_value: cart.cart_value,
      cart_currency: cart.cart_currency || config.currency || '',
      cart_item_count: cart.cart_item_count,
      cart_product_handles: cart.cart_product_handles || [],
      cart_variant_ids: cart.cart_variant_ids || [],
      drawer_checkout_visible: !!checkout
    }, extra || {});
  }

  function refreshCartContext() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'X-Anatomy-Tracking-Read': '1' },
      credentials: 'same-origin'
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (cart) {
      return cart ? updateCartContext(cart) : cartContext();
    }).catch(function () {
      return cartContext();
    });
  }

  function bindCartDrawer() {
    var lastDrawerAction = 'programmatic';

    document.addEventListener('drawer:afterShow', function (event) {
      var drawer = event.target && event.target.closest ? event.target.closest('[data-an-cart-drawer], cart-drawer') : null;
      if (!drawer || drawer.id !== 'CartDrawer') return;
      lastDrawerAction = 'open';
      refreshCartContext().then(function () {
        capture('an_cart_drawer_opened', cartDrawerProps(drawer));
        var checkout = drawer.querySelector('[data-an-cart-drawer-action="checkout"]');
        if (checkout) capture('an_cart_drawer_checkout_visible', Object.assign(cartDrawerProps(drawer), ctaProps(checkout)));
      });
    });

    document.addEventListener('drawer:afterHide', function (event) {
      var drawer = event.target && event.target.closest ? event.target.closest('[data-an-cart-drawer], cart-drawer') : null;
      if (!drawer || drawer.id !== 'CartDrawer') return;
      capture('an_cart_drawer_closed', cartDrawerProps(drawer, { drawer_close_reason: lastDrawerAction }));
      lastDrawerAction = 'programmatic';
    });

    document.addEventListener('click', function (event) {
      var actionTarget = event.target && event.target.closest
        ? event.target.closest('[data-an-cart-drawer-action]')
        : null;
      if (!actionTarget) return;
      var drawer = actionTarget.closest('[data-an-cart-drawer], cart-drawer');
      if (!drawer || drawer.id !== 'CartDrawer') return;
      var action = actionTarget.getAttribute('data-an-cart-drawer-action') || 'unknown';
      lastDrawerAction = action;
      var eventName = {
        checkout: 'an_cart_drawer_checkout_clicked',
        close: 'an_cart_drawer_close_clicked',
        continue_shopping: 'an_cart_drawer_continue_shopping_clicked',
        view_cart: 'an_cart_drawer_view_cart_clicked',
        cross_sell: 'an_cart_drawer_cross_sell_clicked'
      }[action] || 'an_cart_drawer_action_clicked';
      capture(eventName, Object.assign(cartDrawerProps(drawer, { cart_drawer_action: action }), ctaProps(actionTarget)));
    }, true);

    window.addEventListener('anatomy:checkout-redirect-started', function (event) {
      var detail = event && event.detail ? event.detail : {};
      capture('an_checkout_redirect_started', Object.assign({}, readSessionJson(CHECKOUT_INTENT_KEY), {
        checkout_behavior: 'direct',
        checkout_redirect_target: safeUrl(detail.target || '/checkout'),
        checkout_experiment_id: detail.experimentId || '',
        checkout_experiment_variant: detail.variant || ''
      }));
    });
  }

  function bindNetworkOutcomes() {
    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function' && !originalFetch.__ANATOMY_FUNNEL_WRAPPED__) {
      var cartActionType = function (path) {
        if (/\/cart\/add(?:\.js)?$/.test(path)) return 'cart_add';
        if (/\/cart\/change(?:\.js)?$/.test(path)) return 'cart_change';
        if (/\/cart\/update(?:\.js)?$/.test(path)) return 'cart_update';
        return 'cart_unknown';
      };

      var requestHeaderValue = function (headers, name) {
        if (!headers) return '';
        var lowerName = String(name || '').toLowerCase();

        try {
          if (typeof Headers !== 'undefined' && headers instanceof Headers) {
            return headers.get(name) || '';
          }
        }
        catch (error) {}

        if (Array.isArray(headers)) {
          for (var index = 0; index < headers.length; index += 1) {
            if (headers[index] && String(headers[index][0] || '').toLowerCase() === lowerName) {
              return headers[index][1] || '';
            }
          }
          return '';
        }

        try {
          for (var key in headers) {
            if (Object.prototype.hasOwnProperty.call(headers, key) && String(key).toLowerCase() === lowerName) {
              return headers[key] || '';
            }
          }
        }
        catch (error) {}

        return '';
      };

      var isAttributionCartSync = function (args, path) {
        if (!/\/cart\/update(?:\.js)?$/.test(path || '')) return false;
        var request = args[0];
        var options = args[1] || {};
        var headerValue = requestHeaderValue(options.headers, CART_ATTRIBUTION_SYNC_HEADER);
        if (!headerValue && request && request.headers) {
          headerValue = requestHeaderValue(request.headers, CART_ATTRIBUTION_SYNC_HEADER);
        }
        return headerValue === '1' || headerValue === 'true';
      };

      var captureCartActionResult = function (response, path, startedAt) {
        var props = {
          cart_action_path: path,
          cart_action_type: cartActionType(path),
          cart_action_status: response.status,
          cart_action_status_text: response.statusText || '',
          cart_action_duration_ms: Date.now() - startedAt
        };

        if (response.ok) {
          if (response.clone && typeof response.clone === 'function') {
            response.clone().json().then(function (payload) {
              if (payload && Array.isArray(payload.items)) {
                Object.assign(props, updateCartContext(payload));
              }
              else if (payload) {
                props.product_id = payload.product_id || '';
                props.variant_id = payload.variant_id || payload.id || '';
                props.quantity = payload.quantity || 1;
                props.line_price = typeof payload.final_line_price === 'number' ? payload.final_line_price / 100 : undefined;
              }
              capture('an_cart_action_succeeded', props, UNLOAD_SAFE_CAPTURE);
            }).catch(function () {
              capture('an_cart_action_succeeded', props, UNLOAD_SAFE_CAPTURE);
            });
          }
          else {
            capture('an_cart_action_succeeded', props, UNLOAD_SAFE_CAPTURE);
          }
          return;
        }

        if (response.clone) {
          response.clone().text().then(function (text) {
            if (text) props.cart_action_response = text.slice(0, 500);
            capture('an_cart_action_failed', props);
          }).catch(function () {
            capture('an_cart_action_failed', props);
          });
          return;
        }

        capture('an_cart_action_failed', props);
      };

      var wrappedFetch = function () {
        var args = arguments;
        var startedAt = Date.now();
        var url = '';
        try {
          url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
        }
        catch (error) {}

        return originalFetch.apply(this, args).then(function (response) {
          var path = pathFromUrl(url);
          if (isAttributionCartSync(args, path)) return response;
          if (/\/cart\/add(?:\.js)?$/.test(path) || /\/cart\/change(?:\.js)?$/.test(path) || /\/cart\/update(?:\.js)?$/.test(path)) {
            captureCartActionResult(response, path, startedAt);
            // Persist attribution onto the cart the moment its contents change via
            // AJAX (add/change) — not only at checkout-click — so abandoned carts
            // and Klaviyo flows still carry first/last-touch. syncPostHogCartAttributes
            // POSTs /cart/update with CART_ATTRIBUTION_SYNC_HEADER, which
            // isAttributionCartSync() filters above, so this cannot recurse. It is
            // forced (the add may have created the cart) and keepalive: the
            // landing-page direct checkout navigates 250 ms after the add.
            if (response.ok && (/\/cart\/add(?:\.js)?$/.test(path) || /\/cart\/change(?:\.js)?$/.test(path))) {
              syncPostHogCartAttributes('ajax_cart_mutation', true, true);
            }
          }
          return response;
        }).catch(function (error) {
          var path = pathFromUrl(url);
          if (isAttributionCartSync(args, path)) throw error;
          if (/\/cart\/add(?:\.js)?$/.test(path) || /\/cart\/change(?:\.js)?$/.test(path) || /\/cart\/update(?:\.js)?$/.test(path)) {
            capture('an_cart_action_failed', {
              cart_action_path: path,
              cart_action_type: cartActionType(path),
              cart_action_status: 0,
              cart_action_error: error && error.name ? error.name : 'network_error',
              cart_action_duration_ms: Date.now() - startedAt
            });
          }
          throw error;
        });
      };
      wrappedFetch.__ANATOMY_FUNNEL_WRAPPED__ = true;
      window.fetch = wrappedFetch;
    }
  }

  function captureOfferSignal() {
    var offerCode = detectOfferCode();
    if (!offerCode) return;

    var signature = offerCode + '|' + window.location.pathname;
    try {
      if (window.sessionStorage.getItem(OFFER_SIGNAL_KEY) === signature) return;
      window.sessionStorage.setItem(OFFER_SIGNAL_KEY, signature);
    }
    catch (error) {}

    capture('an_offer_code_detected', {
      offer_code: offerCode,
      offer_source: window.location.pathname.indexOf('/discount/') === 0 ? 'discount_path' : 'query_or_session',
      offer_landing_path: window.location.pathname
    });
  }

  function bindIdentitySignals() {
    window.addEventListener('anatomy:klaviyo-identity-synced', function (event) {
      var detail = event && event.detail ? event.detail : {};
      capture('an_email_identity_synced', {
        identity_sync_reason: detail.reason || '',
        identity_property_count: detail.propertyKeys && detail.propertyKeys.length ? detail.propertyKeys.length : 0
      });
      syncPostHogCartAttributes('email_identity_synced', true);
    });

    // Identity is owned solely by anatomy-klaviyo-identity-sync.js, which calls
    // posthog.identify() with a hashed email (email_sha256_<hash>) on Klaviyo
    // form submit and on the anatomy:identify-email event — consent-gated and
    // session-deduped. We intentionally do NOT identify here: a second listener
    // calling posthog.identify(rawEmail) competed with the hashed-email identity
    // (two distinct_ids for one person). This file only reacts to the resulting
    // anatomy:klaviyo-identity-synced event (handler above).

    // Reset identity on logout so a shared device never merges two customers.
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      if (/\/account\/logout/.test(link.getAttribute('href') || '')) {
        try {
          if (analyticsAllowed() && window.posthog && typeof window.posthog.reset === 'function') {
            window.posthog.reset();
            registerTrafficFlags();
          }
        }
        catch (error) {}
      }
    }, true);
  }

  function bindScrollDepth() {
    function onScroll() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop || 0;
      var height = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var depth = Math.round((scrollTop / height) * 100);
      SCROLL_DEPTHS.forEach(function (target) {
        if (depth >= target && !scrollSeen[target]) {
          scrollSeen[target] = true;
          capture('an_scroll_depth_reached', { scroll_depth: target });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindSectionViews() {
    if (!('IntersectionObserver' in window)) return;
    // Volume control: an_section_viewed is a content-engagement funnel step, and
    // funnels count DISTINCT USERS (not raw events), so one event per page load is
    // sufficient. Firing once per section made this ~31% of all events (~6,975/wk)
    // with no funnel benefit. Capture the first qualifying section, then stop.
    var captured = false;
    var observer = new IntersectionObserver(function (entries) {
      if (captured) return;
      entries.forEach(function (entry) {
        if (captured || !entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        var element = entry.target;
        var key = element.getAttribute('id') || element.getAttribute('data-section-type') || element.className || '';
        key = key.toString().slice(0, 180);
        if (!key) return;
        captured = true;
        capture('an_section_viewed', {
          section_key: key,
          section_text_sample: textOf(element).slice(0, 220)
        });
        observer.disconnect();
      });
    }, { threshold: [0.35] });

    document.querySelectorAll('section, .lp-angle-hero, .lp-bundle-protocol, .lp-system-selector, .lp-products-trio, .lp-final-cta, .lp-results-proof, .lp-microscopy-proof').forEach(function (element) {
      observer.observe(element);
    });
  }

  function bindDecisionViews() {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
        var element = entry.target;
        var key = element.getAttribute('id') || element.getAttribute('data-product-handle') || element.className || textOf(element);
        key = key.toString().slice(0, 180);
        if (!key || seen[key]) return;
        seen[key] = true;

        if (element.matches('[data-an-product-recommendation]')) {
          capture('an_product_recommendation_seen', {
            product_handle: element.getAttribute('data-product-handle') || '',
            product_title: element.getAttribute('data-product-title') || '',
            product_price: element.getAttribute('data-product-price') || '',
            recommendation_location: closestLabel(element)
          });
        }

        if (element.matches('[data-an-system-selector]')) {
          capture('an_system_selector_viewed', productModuleProps(element));
        }

        if (element.matches('[data-an-selector-card]')) {
          capture('an_product_selector_choice_viewed', productModuleProps(element));
        }

        if (element.matches('[data-lp-checkout-form]')) {
          var formCta = element.querySelector ? element.querySelector('button[type="submit"], input[type="submit"], a[href]') : null;
          var checkoutVisibilityProps = Object.assign({
            form_id: element.getAttribute('id') || '',
            variant_id: element.getAttribute('data-lp-variant-id') || '',
            checkout_behavior: checkoutBehavior(element),
            checkout_experiment_id: element.getAttribute('data-an-checkout-experiment') || '',
            form_action: element.getAttribute('action') || ''
          }, productModuleProps(element), ctaProps(formCta || element));
          capture(checkoutVisibilityProps.checkout_behavior === 'direct' ? 'an_checkout_cta_visible' : 'an_add_to_cart_cta_visible', checkoutVisibilityProps);
          if (checkoutVisibilityProps.is_product_module_context) {
            capture('an_product_module_cta_visible', checkoutVisibilityProps);
          }
        }

        if (element.matches('[data-an-product-module]')) {
          capture('an_product_module_viewed', productModuleProps(element));
          capture('an_product_offer_state_viewed', productOfferProps(element));
        }

        if (element.matches('[data-an-email-capture]')) {
          capture('an_email_capture_visible', emailCaptureProps(element));
        }

        if (element.matches('[data-an-cart-cross-sell]')) {
          capture('an_cart_cross_sell_viewed', {
            cross_sell_id: element.getAttribute('data-an-cart-cross-sell') || '',
            cross_sell_products: (element.getAttribute('data-an-cross-sell-products') || '').split(',').filter(Boolean),
            cart_routine_count: Number(element.getAttribute('data-an-cart-routine-count') || 0),
            cross_sell_location: closestLabel(element)
          });
        }
      });
    }, { threshold: [0.45] });

    document.querySelectorAll('[data-an-product-recommendation], [data-an-system-selector], [data-an-selector-card], [data-an-product-module], [data-lp-checkout-form], [data-an-email-capture], [data-an-cart-cross-sell]').forEach(function (element) {
      observer.observe(element);
    });
  }

  function bindKlaviyoForms() {
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var formId = detail.formId || detail.formID || '';
      var formHosts = formId ? document.querySelectorAll('[data-klaviyo-form-id="' + formId + '"]') : [];
      var formHost = null;
      Array.prototype.some.call(formHosts, function (candidate) {
        if (candidate.offsetParent !== null) {
          formHost = candidate;
          return true;
        }
        return false;
      });
      if (!formHost && formHosts.length) formHost = formHosts[0];
      var metadata = detail.metaData || {};
      var submittedFields = [];
      try {
        submittedFields = Object.keys(metadata).filter(function (key) {
          return !/email|phone|name|address/i.test(key);
        });
      }
      catch (error) {}

      var props = emailCaptureProps(formHost, {
        klaviyo_event_type: detail.type || '',
        klaviyo_form_id: formId,
        klaviyo_company_id: detail.companyId || detail.companyID || '',
        capture_step: detail.step || detail.stepNumber || '',
        capture_variant: detail.variant || detail.formVersion || '',
        submitted_field_keys: submittedFields
      });

      if (detail.type === 'submit') {
        capture('an_email_capture_submitted', props);
      }
      else if (detail.type === 'stepSubmit') {
        capture('an_email_capture_step_submitted', props);
      }
      else if (detail.type === 'embedOpen' || detail.type === 'open') {
        capture('an_email_capture_opened', props);
      }
      else if (detail.type) {
        capture('an_klaviyo_form_event', props);
      }
    });
  }

  function bindPageQuality() {
    try {
      if ('PerformanceObserver' in window) {
        var lcpObserver = new PerformanceObserver(function (entryList) {
          var entries = entryList.getEntries();
          var entry = entries[entries.length - 1];
          if (entry) largestContentfulPaintMs = entry.startTime || 0;
        });
        lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
      }
    }
    catch (error) {}

    if (document.readyState === 'complete') {
      window.setTimeout(function () { capturePageQuality('document_complete'); }, 1800);
    }
    else {
      window.addEventListener('load', function () {
        window.setTimeout(function () { capturePageQuality('window_load'); }, 1800);
      }, { once: true });
    }
    window.setTimeout(function () { capturePageQuality('timeout'); }, 6000);
    window.addEventListener('pagehide', function () { capturePageQuality('pagehide'); }, { once: true });
  }

  var trackingInitialized = false;
  var trackingRevoked = false;

  function revokeTracking() {
    if (window.posthog) {
      try {
        if (typeof window.posthog.reset === 'function') window.posthog.reset(true);
      }
      catch (error) {}
      try {
        if (typeof window.posthog.opt_out_capturing === 'function') {
          window.posthog.opt_out_capturing({ clear_persistence: true });
        }
      }
      catch (error) {}
    }
    trackingRevoked = true;
    clearTrackingState();
  }

  function initializeTracking(snapshot) {
    if (!analyticsAllowed()) {
      if (snapshot && (snapshot.status === 'ready' || snapshot.status === 'error')) {
        reconcileCartAttributesForPrivacy();
        revokeTracking();
      }
      return;
    }

    sanitizeStoredPurposeState();
    var needsPrivacyReconciliation = !marketingAllowed() || !advertisingAllowed();
    if (needsPrivacyReconciliation) reconcileCartAttributesForPrivacy();

    if (trackingInitialized) {
      if (trackingRevoked && window.posthog && typeof window.posthog.reset === 'function') {
        window.posthog.reset(true);
      }
      if (window.posthog && typeof window.posthog.opt_in_capturing === 'function') {
        window.posthog.opt_in_capturing();
      }
      trackingRevoked = false;
      synchronizeVisitorIdWithPostHog();
      registerTrafficFlags();
      if (!needsPrivacyReconciliation) syncPostHogCartAttributes('privacy_consent_changed', false);
      return;
    }

    trackingInitialized = true;
    trackingRevoked = false;
    loadPostHog();
    bindClicks();
    bindCartDrawer();
    bindNetworkOutcomes();
    bindCheckoutHandoffReturns();
    bindScrollDepth();
    bindSectionViews();
    bindDecisionViews();
    bindKlaviyoForms();
    bindIdentitySignals();
    bindPageQuality();
    captureOfferSignal();
  }

  var privacy = window.AnatomyCustomerPrivacy;
  if (privacy && typeof privacy.subscribe === 'function') {
    privacy.subscribe(initializeTracking);
  }
})();
